"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _context = require("../context");

var _utils = require("../utils");

var _constants = require("./constants");

var Background = (0, _context.styledWithTheme)('span')(function (_ref) {
  var selectors = _ref.theme.selectors,
      isDisabled = _ref.isDisabled,
      active = _ref.active;
  var backgroundColor = selectors.color(isDisabled ? 'neutral05' : active ? 'primary70' : 'neutral10');
  var borderColor = selectors.color(isDisabled ? 'neutral50' : active ? 'primary70' : 'primary70');
  return "\n    position: relative;\n    display: inline-block;\n    margin: ".concat((_utils.A11Y_INLINE_MIN_SIZE - _constants.BAR_HEIGHT) / 2, "px 0;\n    width: 40px;\n    height: ").concat(_constants.BAR_HEIGHT, "px;\n    background-color: ").concat(backgroundColor, ";\n    border-radius: 16px;\n    box-sizing: border-box;\n    border: ").concat(_constants.BORDER_WIDTH, "px solid ").concat(borderColor, ";\n    transition: all 0.2s ease;");
});
Background.displayName = 'Background';
var _default = Background;
exports.default = _default;